import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Unauthorized from './components/Unauthorized/Unauthorized';
import RequiredAuth from './auth/RequiredAuth';
import CustomLoginCallback from './auth/CustomLoginCallback';
import AuthenticatedLayout from './components/Layout/AuthenticatedLayout';
import { RbacProvider, useRbac, RoleSelector } from './auth/rbac';
import './App.css';

/**
 * Gate that shows the RoleSelector page when a multi-role user
 * has not yet chosen a role, otherwise renders the main app.
 */
const RbacGate: React.FC = () => {
  const { canSwitchRoles, roleSelected } = useRbac();

  if (canSwitchRoles && !roleSelected) {
    return <RoleSelector />;
  }

  return <AuthenticatedLayout />;
};

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/callback" element={<CustomLoginCallback />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route element={<RequiredAuth />}>
        <Route path="/*" element={
          <RbacProvider>
            <RbacGate />
          </RbacProvider>
        } />
      </Route>
    </Routes>
  );
};

export default App;
